import { useEffect } from 'react'

import Auth from '../store/auth'

import { postAxiosSingle } from 'pages/api/axios'
import { URL_LIST } from 'constants/url'
import { StatusVocabulary } from 'constants/data'

const useFuturePageVisited = ({ id, status }: { id: number; status: 1 | 2 | 3 | 4 }): void => {
  const { isAuthorized } = Auth.useAuth()
  
  useEffect(() => {
    const setView = async () => {
      const isFuture = status === StatusVocabulary.FUTURE || status === StatusVocabulary.HOUR_BEFORE
      if (isFuture) await postAxiosSingle(URL_LIST.FUTURE_PAGE_VISIT, {}, { id: Number(id) })
    }

    setView()
  }, [id, isAuthorized])
}

export default useFuturePageVisited
